function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Toaster } from 'react-hot-toast';
import App, { IntlHelmet, LanguageProvider, LanguageSelector, OfflineOverlay } from 'modules/App';
import messages from '../../messages';
import styles from './LogoLayout.pcss';
var _React_Component;
class LogoLayout extends (_React_Component = React.Component) {
    onKeyDown(evt) {
        // If ESC
        if (evt.keyCode === 27) {
            this.props.onCloseDropdown();
        }
    }
    render() {
        const titleMessage = this.props.metaTitleMessage ? this.props.metaTitleMessage : _object_spread({}, messages.meta.title);
        const descriptionMessage = this.props.metaDescriptionMessage ? this.props.metaDescriptionMessage : _object_spread({}, messages.meta.description);
        return /*#__PURE__*/ _jsx(LanguageProvider, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.root, 'no-gutters'),
                onClick: this.props.onCloseDropdown,
                onKeyDown: (evt)=>this.onKeyDown(evt),
                children: [
                    /*#__PURE__*/ _jsx(IntlHelmet, {
                        titleMessage: titleMessage,
                        descriptionMessage: descriptionMessage
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto d-lg-none",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.mobileLogo,
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/assets/svg/logo.svg",
                                className: styles.mobileLogo__logo,
                                alt: "Ascensia Diabetes Care"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: cn('col col-lg-8', styles.container),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.containerInner,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "content",
                                    children: this.props.children
                                })
                            }),
                            /*#__PURE__*/ _jsx(LanguageSelector, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-none d-lg-block col-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.logoSidebar,
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/assets/svg/logo.svg",
                                className: styles.logoSidebar__logo,
                                alt: "Ascensia Diabetes Care"
                            })
                        })
                    }),
                    process.env.BROWSER && /*#__PURE__*/ _jsx(Toaster, {
                        position: "top-right"
                    }),
                    /*#__PURE__*/ _jsx(OfflineOverlay, {})
                ]
            })
        });
    }
}
_define_property(LogoLayout, "propTypes", {
    // Explicit props
    metaTitleMessage: PropTypes.object,
    metaDescriptionMessage: PropTypes.object,
    // Implicit props
    children: PropTypes.node,
    // Implicit actions
    onCloseDropdown: PropTypes.func
});
const mapDispatchToProps = (dispatch)=>({
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown())
    });
const ConnectedLogoLayout = connect(null, mapDispatchToProps)(LogoLayout);
export default withStyles(styles)(ConnectedLogoLayout);
